<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  placeholder="Key in job band value here"
                  append-icon="search"
                  label="Search Job Band"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Job Band's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-job-bands-dialog-create
                  v-if="$hasPermissionTo(['create job bands'])" 
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredJobBands"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item="props">
              <tr>
                <td>{{ props.item.value }}</td>
                <td>
                  <helper-image-input  
                    v-model="images[props.item.id]"              
                    :max-size-in-mb="2"
                    data-vv-name="image"
                    field-name="image"
                    accept-type=".svg"    
                    extension="ext:svg"          
                  >  
                    <v-avatar 
                      slot="activator"
                      class="cursor-pointer"
                      tile
                    >
                      <img :src="images[props.item.id] ? images[props.item.id].imageURL : props.item.image_url">       
                    </v-avatar>                            
                  </helper-image-input>   
                  <template v-if="images[props.item.id]">         
                    <v-btn 
                      :disabled="saving"
                      text
                      icon
                      @click="resetImageHolder(props.item.id)"
                    >
                      <v-icon size="30">
                        mdi-close-circle-outline
                      </v-icon>
                    </v-btn>     
                    <v-btn 
                      :loading="saving"
                      text
                      icon
                      color="primary"
                      @click="uploadImage(props.item.id)"
                    >
                      <v-icon size="30">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </template>  
                </td>
                <td>
                  <span v-if="statusFilter">
                    <setup-job-bands-dialog-edit
                      v-if="$hasPermissionTo(['update job bands'])" 
                      :job-band="props.item"
                      @updated="loadData"
                    />
                    <span class="mx-1" />
                    <setup-job-bands-dialog-delete
                      v-if="$hasPermissionTo(['delete job bands'])" 
                      :job-band="props.item"
                      @deleted="loadData"
                    />
                  </span>
                  <span v-else>
                    <setup-job-bands-dialog-restore
                      v-if="$hasPermissionTo(['delete job bands'])" 
                      :job-band="props.item"
                      @restored="loadData"
                    />
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>     
  </v-container>
</template>

<script>
  export default {
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
      SetupJobBandsDialogCreate: () => import('@/components/setup/job/bands/DialogCreate'),
      SetupJobBandsDialogDelete: () => import('@/components/setup/job/bands/DialogDelete'),
      SetupJobBandsDialogRestore: () => import('@/components/setup/job/bands/DialogRestore'),
      SetupJobBandsDialogEdit: () => import('@/components/setup/job/bands/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Job Bands',
      }
    },
    data () {
      return {
        jobBands: [],
        trashedJobBands: [],
        headers: [
          {
            text: 'Value',
            align: 'left',
            value: 'value',
          },
          {
            text: 'Logo',
            align: 'left',
            sortable: false,
            value: '',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        images: [],
        saving: false,
      }
    },
    computed: {
      filteredJobBands () {
        return this.statusFilter ? this.jobBands : this.trashedJobBands
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobBands().list(),
          this.$api.jobBands().listTrashed(),
        ]).then(([jobBands, trashedJobBands]) => {
          this.jobBands = jobBands.data
          this.trashedJobBands = trashedJobBands.data

          this.tableLoading = false
        })
      },

      resetImageHolder (id) {
        this.$set(this.images, id, null)
      },

      uploadImage (id) {
        this.saving = true

        this.$api.jobBands().uploadImage(id, this.images[id].formData)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.savedImage(id)
            }
          })
          .catch(() => {
            this.$snack({
              color: 'error',
              message: 'Photo upload failed, please try again',
            })
          }) 
          .then(() => {
            this.saving = false
          })
      },

      savedImage (id) {     
        this.$api.jobBands().list()
          .then(response => {
            this.jobBands = response.data

            this.images[id] = null
          })      

        this.$snack({
          message: 'Photo uploaded successfully!',
        })
      },
    },
  }
</script>

<style scoped>
  ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }

  ::v-deep .v-table__overflow{
    overflow-x: hidden;
  }

  .cursor-pointer{
    cursor: pointer;
  }
</style>
